import useDockyardForm from "$hooks/useDockyardForm";
import DockyardForm from "./DockyardForm";

export const DockyardPopin = ({ togglePopin }: any) => {
  const { handleSubmit, error, submitting } = useDockyardForm(
    undefined,
    togglePopin
  );
  return (
    <DockyardForm
      onSubmit={handleSubmit}
      onCancel={() => togglePopin(false)}
      isSubmitting={submitting}
      error={error}
    />
  );
};
